// extracted by extract-css-chunks-webpack-plugin
module.exports = {"protocol":"protocol_gPgaD","list":"list_BXQRV"};